import React, { useEffect, useRef, useState } from 'react';
import styles from './CheckboxItem.module.scss';
import { CheckboxItemProps } from './CheckboxItem.type';

const UncheckedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <mask
      id="mask0_2837_25448"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#18B5BD" />
    </mask>
    <g mask="url(#mask0_2837_25448)">
      <rect x="0.5" y="0.5" width="17" height="17" rx="1.5" stroke="#18B5BD" />
    </g>
  </svg>
);

const CheckedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <rect x="2" y="3" width="13" height="13" fill="#E4E4E4" />
    <mask
      id="mask0_2837_25451"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2837_25451)">
      <path
        d="M7.6 13.2L14.65 6.15L13.25 4.75L7.6 10.4L4.75 7.55L3.35 8.95L7.6 13.2ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2Z"
        fill="#A41655"
      />
      <rect x="0.5" y="0.5" width="17" height="17" rx="1.5" stroke="#CD1C6A" />
    </g>
  </svg>
);

const CheckboxItem: React.FC<CheckboxItemProps> = ({
  title = '0',
  defaultState = false,
  onClick
}) => {
  const isFirstRender = useRef(true);
  const [checked, setChecked] = useState<boolean>(defaultState);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (onClick) onClick(checked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);
  return (
    <div
      className={styles['Container']}
      data-testid="checkbox-item"
      onClick={() => {
        setChecked((s) => !s);
      }}
    >
      <div>{checked ? <CheckedIcon /> : <UncheckedIcon />}</div>
      <p>{title}</p>
    </div>
  );
};

export default CheckboxItem;
